/* tslint:disable */
/* eslint-disable */
export enum ReportTypes {
  Agency = 'Agency',
  FoodSource = 'FoodSource',
  Waste = 'Waste'
}
